module.exports = __webpack_public_path__ + "static/media/twitterLogo.7fc95a7e.png";